import React from 'react';

export default function IllusionerHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="35.44,38.0 11.69,38.0 11.69,5.56 35.44,5.56" fill="#395365" />
      <polygon points="11.69,38.0 35.44,38.0 28.31,34.44 4.56,34.44" fill="#141D23" opacity="0.95" />
      <polygon points="11.69,38.0 4.56,34.44 4.56,2.0 11.69,5.56" fill="#141D23" opacity="0.95" />
    </svg>
  );
}
